/** The class names that apply, joined: shadcn's `cn` without tailwind-merge (kit components never pass two utilities for one property). */
export function cn(...parts: readonly (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}
